import type { RootState } from '@core/core/store'
import type { ProjectType } from '@core/core/types'
import { createSelector } from '@reduxjs/toolkit'
import type { Nullable } from 'common/types'

import { projectTypesAdapter } from './projectTypesSlice'

export const { selectAll: selectAllProjectTypes } = projectTypesAdapter.getSelectors<RootState>(
  state => state.projectTypes,
)

export const selectProjectType = createSelector(
  [selectAllProjectTypes, (_, type?: Nullable<ProjectType>) => type],
  (allTypes, projectType): string | undefined => {
    return allTypes.find(type => type.id === projectType)?.name
  },
)
